const {
  ResourcesByLocationExportButton,
} = require("src/client-ts/containers/Estimation/ExcelExport/ResourcesByLocation");

exports.resourcesByLocationExportButton = ResourcesByLocationExportButton;
